import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { MenuToogle } from '@pyg-animations/navigation';
import {
  SmoothImageProducts,
  SmoothTextProducts,
} from '@pyg-animations/products';
import { Product, productData } from './products';
import { TranslatePipe } from '@ngx-translate/core';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';
import { GetInfoComponent } from '@pyg-shared/get-info/get-info.component';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
  animations: [SmoothTextProducts, SmoothImageProducts, MenuToogle],
  imports: [TranslatePipe, GetDemoComponent, GetInfoComponent, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDescriptionComponent {
  public readonly products: Product[] = productData;
  public readonly dataState = signal<'entering' | 'done'>('done');
  public productId = input.required<number>();

  constructor() {
    effect(() => {
      this.productId();
      this.dataState.set('entering');
    });
  }
}
